import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
//import App from './App';
import Imagesdisplay from './Imagesdisplay'
import reportWebVitals from './reportWebVitals';
import LoginForm from './LoginForm';
import ProfilePage from './ProfilePage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Imagesdisplay />
    <LoginForm />
    <ProfilePage />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
